/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UnauthenticatedSubscriptionFormRouteImport } from './routes/_unauthenticated/subscription-form'
import { Route as UnauthenticatedInvestorRegistrationRouteImport } from './routes/_unauthenticated/investor-registration'
import { Route as UnauthenticatedCostCalculatorRouteImport } from './routes/_unauthenticated/cost-calculator'
import { Route as UnauthenticatedAffordabilityCalculatorRouteImport } from './routes/_unauthenticated/affordability-calculator'
import { Route as UnauthenticatedAdditionalUploadsInvestorRouteImport } from './routes/_unauthenticated/additional-uploads-investor'
import { Route as AuthenticatedPropertyPurchasePlanRouteImport } from './routes/_authenticated/property-purchase-plan'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedPfidaRouteImport } from './routes/_authenticated/_pfida'
import { Route as UnauthenticatedauthRoutesSignupRouteImport } from './routes/_unauthenticated/(auth-routes)/signup'
import { Route as UnauthenticatedauthRoutesLoginRouteImport } from './routes/_unauthenticated/(auth-routes)/login'
import { Route as UnauthenticatedauthRoutesForgotPasswordRouteImport } from './routes/_unauthenticated/(auth-routes)/forgot-password'
import { Route as AuthenticatedPropertyPurchasePlanIdRouteImport } from './routes/_authenticated/property-purchase-plan_.$id'
import { Route as AuthenticatedCalculatorsCostCalculatorRouteImport } from './routes/_authenticated/calculators/cost-calculator'
import { Route as AuthenticatedCalculatorsCalculationHistoryRouteImport } from './routes/_authenticated/calculators/calculation-history'
import { Route as AuthenticatedCalculatorsAffordabilityCalculatorRouteImport } from './routes/_authenticated/calculators/affordability-calculator'
import { Route as AuthenticatedCalculatorsAcceptancePrincipleRouteImport } from './routes/_authenticated/calculators/acceptance-principle'
import { Route as AuthenticatedPfidaReferralsRouteImport } from './routes/_authenticated/_pfida/referrals'
import { Route as AuthenticatedPfidaLegalNoticesRouteImport } from './routes/_authenticated/_pfida/legal-notices'
import { Route as AuthenticatedPfidaInvestorTypeRouteImport } from './routes/_authenticated/_pfida/investor-type'
import { Route as AuthenticatedPfidaInvestorHubRouteImport } from './routes/_authenticated/_pfida/investor-hub'
import { Route as AuthenticatedPfidaIfaApprovalRouteImport } from './routes/_authenticated/_pfida/ifa-approval'
import { Route as AuthenticatedPfidaGrowYourSavingsRouteImport } from './routes/_authenticated/_pfida/grow-your-savings'
import { Route as AuthenticatedPfidaFinanceRequirementsRouteImport } from './routes/_authenticated/_pfida/finance-requirements'
import { Route as AuthenticatedPfidaDocumentsRouteImport } from './routes/_authenticated/_pfida/documents'
import { Route as AuthenticatedPfidaDipRouteImport } from './routes/_authenticated/_pfida/dip'
import { Route as AuthenticatedPfidaCalculatorsRouteImport } from './routes/_authenticated/_pfida/calculators'
import { Route as AuthenticatedPfidaBankDetailsRouteImport } from './routes/_authenticated/_pfida/bank-details'
import { Route as AuthenticatedPfidaAccountSettingsRouteImport } from './routes/_authenticated/_pfida/account-settings'
import { Route as AuthenticatedPfidaAboutRouteImport } from './routes/_authenticated/_pfida/about'
import { Route as UnauthenticatedauthRoutesSignupConfirmRouteImport } from './routes/_unauthenticated/(auth-routes)/signup_.confirm'
import { Route as UnauthenticatedauthRoutesLoginChallengePasswordRouteImport } from './routes/_unauthenticated/(auth-routes)/login_.challenge-password'
import { Route as UnauthenticatedauthRoutesLoginConfimRouteImport } from './routes/_unauthenticated/(auth-routes)/login.confim'
import { Route as UnauthenticatedauthRoutesForgotPasswordConfirmRouteImport } from './routes/_unauthenticated/(auth-routes)/forgot-password_.confirm'
import { Route as AuthenticatedCalculatorsAcceptancePrincipleResultRouteImport } from './routes/_authenticated/calculators/acceptance-principle_.result'
import { Route as AuthenticatedPfidaGrowYourSavingsIdRouteImport } from './routes/_authenticated/_pfida/grow-your-savings_.$id'

const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedSubscriptionFormRoute =
  UnauthenticatedSubscriptionFormRouteImport.update({
    id: '/subscription-form',
    path: '/subscription-form',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedInvestorRegistrationRoute =
  UnauthenticatedInvestorRegistrationRouteImport.update({
    id: '/investor-registration',
    path: '/investor-registration',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedCostCalculatorRoute =
  UnauthenticatedCostCalculatorRouteImport.update({
    id: '/cost-calculator',
    path: '/cost-calculator',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedAffordabilityCalculatorRoute =
  UnauthenticatedAffordabilityCalculatorRouteImport.update({
    id: '/affordability-calculator',
    path: '/affordability-calculator',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedAdditionalUploadsInvestorRoute =
  UnauthenticatedAdditionalUploadsInvestorRouteImport.update({
    id: '/additional-uploads-investor',
    path: '/additional-uploads-investor',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedPropertyPurchasePlanRoute =
  AuthenticatedPropertyPurchasePlanRouteImport.update({
    id: '/property-purchase-plan',
    path: '/property-purchase-plan',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPfidaRoute = AuthenticatedPfidaRouteImport.update({
  id: '/_pfida',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const UnauthenticatedauthRoutesSignupRoute =
  UnauthenticatedauthRoutesSignupRouteImport.update({
    id: '/(auth-routes)/signup',
    path: '/signup',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedauthRoutesLoginRoute =
  UnauthenticatedauthRoutesLoginRouteImport.update({
    id: '/(auth-routes)/login',
    path: '/login',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedauthRoutesForgotPasswordRoute =
  UnauthenticatedauthRoutesForgotPasswordRouteImport.update({
    id: '/(auth-routes)/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedPropertyPurchasePlanIdRoute =
  AuthenticatedPropertyPurchasePlanIdRouteImport.update({
    id: '/property-purchase-plan_/$id',
    path: '/property-purchase-plan/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalculatorsCostCalculatorRoute =
  AuthenticatedCalculatorsCostCalculatorRouteImport.update({
    id: '/calculators/cost-calculator',
    path: '/calculators/cost-calculator',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalculatorsCalculationHistoryRoute =
  AuthenticatedCalculatorsCalculationHistoryRouteImport.update({
    id: '/calculators/calculation-history',
    path: '/calculators/calculation-history',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalculatorsAffordabilityCalculatorRoute =
  AuthenticatedCalculatorsAffordabilityCalculatorRouteImport.update({
    id: '/calculators/affordability-calculator',
    path: '/calculators/affordability-calculator',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalculatorsAcceptancePrincipleRoute =
  AuthenticatedCalculatorsAcceptancePrincipleRouteImport.update({
    id: '/calculators/acceptance-principle',
    path: '/calculators/acceptance-principle',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPfidaReferralsRoute =
  AuthenticatedPfidaReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaLegalNoticesRoute =
  AuthenticatedPfidaLegalNoticesRouteImport.update({
    id: '/legal-notices',
    path: '/legal-notices',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaInvestorTypeRoute =
  AuthenticatedPfidaInvestorTypeRouteImport.update({
    id: '/investor-type',
    path: '/investor-type',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaInvestorHubRoute =
  AuthenticatedPfidaInvestorHubRouteImport.update({
    id: '/investor-hub',
    path: '/investor-hub',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaIfaApprovalRoute =
  AuthenticatedPfidaIfaApprovalRouteImport.update({
    id: '/ifa-approval',
    path: '/ifa-approval',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaGrowYourSavingsRoute =
  AuthenticatedPfidaGrowYourSavingsRouteImport.update({
    id: '/grow-your-savings',
    path: '/grow-your-savings',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaFinanceRequirementsRoute =
  AuthenticatedPfidaFinanceRequirementsRouteImport.update({
    id: '/finance-requirements',
    path: '/finance-requirements',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaDocumentsRoute =
  AuthenticatedPfidaDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaDipRoute = AuthenticatedPfidaDipRouteImport.update({
  id: '/dip',
  path: '/dip',
  getParentRoute: () => AuthenticatedPfidaRoute,
} as any)
const AuthenticatedPfidaCalculatorsRoute =
  AuthenticatedPfidaCalculatorsRouteImport.update({
    id: '/calculators',
    path: '/calculators',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaBankDetailsRoute =
  AuthenticatedPfidaBankDetailsRouteImport.update({
    id: '/bank-details',
    path: '/bank-details',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaAccountSettingsRoute =
  AuthenticatedPfidaAccountSettingsRouteImport.update({
    id: '/account-settings',
    path: '/account-settings',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)
const AuthenticatedPfidaAboutRoute = AuthenticatedPfidaAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => AuthenticatedPfidaRoute,
} as any)
const UnauthenticatedauthRoutesSignupConfirmRoute =
  UnauthenticatedauthRoutesSignupConfirmRouteImport.update({
    id: '/(auth-routes)/signup_/confirm',
    path: '/signup/confirm',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedauthRoutesLoginChallengePasswordRoute =
  UnauthenticatedauthRoutesLoginChallengePasswordRouteImport.update({
    id: '/(auth-routes)/login_/challenge-password',
    path: '/login/challenge-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedauthRoutesLoginConfimRoute =
  UnauthenticatedauthRoutesLoginConfimRouteImport.update({
    id: '/confim',
    path: '/confim',
    getParentRoute: () => UnauthenticatedauthRoutesLoginRoute,
  } as any)
const UnauthenticatedauthRoutesForgotPasswordConfirmRoute =
  UnauthenticatedauthRoutesForgotPasswordConfirmRouteImport.update({
    id: '/(auth-routes)/forgot-password_/confirm',
    path: '/forgot-password/confirm',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedCalculatorsAcceptancePrincipleResultRoute =
  AuthenticatedCalculatorsAcceptancePrincipleResultRouteImport.update({
    id: '/calculators/acceptance-principle_/result',
    path: '/calculators/acceptance-principle/result',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPfidaGrowYourSavingsIdRoute =
  AuthenticatedPfidaGrowYourSavingsIdRouteImport.update({
    id: '/grow-your-savings_/$id',
    path: '/grow-your-savings/$id',
    getParentRoute: () => AuthenticatedPfidaRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/property-purchase-plan': typeof AuthenticatedPropertyPurchasePlanRoute
  '/additional-uploads-investor': typeof UnauthenticatedAdditionalUploadsInvestorRoute
  '/affordability-calculator': typeof UnauthenticatedAffordabilityCalculatorRoute
  '/cost-calculator': typeof UnauthenticatedCostCalculatorRoute
  '/investor-registration': typeof UnauthenticatedInvestorRegistrationRoute
  '/subscription-form': typeof UnauthenticatedSubscriptionFormRoute
  '/about': typeof AuthenticatedPfidaAboutRoute
  '/account-settings': typeof AuthenticatedPfidaAccountSettingsRoute
  '/bank-details': typeof AuthenticatedPfidaBankDetailsRoute
  '/calculators': typeof AuthenticatedPfidaCalculatorsRoute
  '/dip': typeof AuthenticatedPfidaDipRoute
  '/documents': typeof AuthenticatedPfidaDocumentsRoute
  '/finance-requirements': typeof AuthenticatedPfidaFinanceRequirementsRoute
  '/grow-your-savings': typeof AuthenticatedPfidaGrowYourSavingsRoute
  '/ifa-approval': typeof AuthenticatedPfidaIfaApprovalRoute
  '/investor-hub': typeof AuthenticatedPfidaInvestorHubRoute
  '/investor-type': typeof AuthenticatedPfidaInvestorTypeRoute
  '/legal-notices': typeof AuthenticatedPfidaLegalNoticesRoute
  '/referrals': typeof AuthenticatedPfidaReferralsRoute
  '/calculators/acceptance-principle': typeof AuthenticatedCalculatorsAcceptancePrincipleRoute
  '/calculators/affordability-calculator': typeof AuthenticatedCalculatorsAffordabilityCalculatorRoute
  '/calculators/calculation-history': typeof AuthenticatedCalculatorsCalculationHistoryRoute
  '/calculators/cost-calculator': typeof AuthenticatedCalculatorsCostCalculatorRoute
  '/property-purchase-plan/$id': typeof AuthenticatedPropertyPurchasePlanIdRoute
  '/forgot-password': typeof UnauthenticatedauthRoutesForgotPasswordRoute
  '/login': typeof UnauthenticatedauthRoutesLoginRouteWithChildren
  '/signup': typeof UnauthenticatedauthRoutesSignupRoute
  '/grow-your-savings/$id': typeof AuthenticatedPfidaGrowYourSavingsIdRoute
  '/calculators/acceptance-principle/result': typeof AuthenticatedCalculatorsAcceptancePrincipleResultRoute
  '/forgot-password/confirm': typeof UnauthenticatedauthRoutesForgotPasswordConfirmRoute
  '/login/confim': typeof UnauthenticatedauthRoutesLoginConfimRoute
  '/login/challenge-password': typeof UnauthenticatedauthRoutesLoginChallengePasswordRoute
  '/signup/confirm': typeof UnauthenticatedauthRoutesSignupConfirmRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/property-purchase-plan': typeof AuthenticatedPropertyPurchasePlanRoute
  '/additional-uploads-investor': typeof UnauthenticatedAdditionalUploadsInvestorRoute
  '/affordability-calculator': typeof UnauthenticatedAffordabilityCalculatorRoute
  '/cost-calculator': typeof UnauthenticatedCostCalculatorRoute
  '/investor-registration': typeof UnauthenticatedInvestorRegistrationRoute
  '/subscription-form': typeof UnauthenticatedSubscriptionFormRoute
  '/about': typeof AuthenticatedPfidaAboutRoute
  '/account-settings': typeof AuthenticatedPfidaAccountSettingsRoute
  '/bank-details': typeof AuthenticatedPfidaBankDetailsRoute
  '/calculators': typeof AuthenticatedPfidaCalculatorsRoute
  '/dip': typeof AuthenticatedPfidaDipRoute
  '/documents': typeof AuthenticatedPfidaDocumentsRoute
  '/finance-requirements': typeof AuthenticatedPfidaFinanceRequirementsRoute
  '/grow-your-savings': typeof AuthenticatedPfidaGrowYourSavingsRoute
  '/ifa-approval': typeof AuthenticatedPfidaIfaApprovalRoute
  '/investor-hub': typeof AuthenticatedPfidaInvestorHubRoute
  '/investor-type': typeof AuthenticatedPfidaInvestorTypeRoute
  '/legal-notices': typeof AuthenticatedPfidaLegalNoticesRoute
  '/referrals': typeof AuthenticatedPfidaReferralsRoute
  '/calculators/acceptance-principle': typeof AuthenticatedCalculatorsAcceptancePrincipleRoute
  '/calculators/affordability-calculator': typeof AuthenticatedCalculatorsAffordabilityCalculatorRoute
  '/calculators/calculation-history': typeof AuthenticatedCalculatorsCalculationHistoryRoute
  '/calculators/cost-calculator': typeof AuthenticatedCalculatorsCostCalculatorRoute
  '/property-purchase-plan/$id': typeof AuthenticatedPropertyPurchasePlanIdRoute
  '/forgot-password': typeof UnauthenticatedauthRoutesForgotPasswordRoute
  '/login': typeof UnauthenticatedauthRoutesLoginRouteWithChildren
  '/signup': typeof UnauthenticatedauthRoutesSignupRoute
  '/grow-your-savings/$id': typeof AuthenticatedPfidaGrowYourSavingsIdRoute
  '/calculators/acceptance-principle/result': typeof AuthenticatedCalculatorsAcceptancePrincipleResultRoute
  '/forgot-password/confirm': typeof UnauthenticatedauthRoutesForgotPasswordConfirmRoute
  '/login/confim': typeof UnauthenticatedauthRoutesLoginConfimRoute
  '/login/challenge-password': typeof UnauthenticatedauthRoutesLoginChallengePasswordRoute
  '/signup/confirm': typeof UnauthenticatedauthRoutesSignupConfirmRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/_authenticated/_pfida': typeof AuthenticatedPfidaRouteWithChildren
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/property-purchase-plan': typeof AuthenticatedPropertyPurchasePlanRoute
  '/_unauthenticated/additional-uploads-investor': typeof UnauthenticatedAdditionalUploadsInvestorRoute
  '/_unauthenticated/affordability-calculator': typeof UnauthenticatedAffordabilityCalculatorRoute
  '/_unauthenticated/cost-calculator': typeof UnauthenticatedCostCalculatorRoute
  '/_unauthenticated/investor-registration': typeof UnauthenticatedInvestorRegistrationRoute
  '/_unauthenticated/subscription-form': typeof UnauthenticatedSubscriptionFormRoute
  '/_authenticated/_pfida/about': typeof AuthenticatedPfidaAboutRoute
  '/_authenticated/_pfida/account-settings': typeof AuthenticatedPfidaAccountSettingsRoute
  '/_authenticated/_pfida/bank-details': typeof AuthenticatedPfidaBankDetailsRoute
  '/_authenticated/_pfida/calculators': typeof AuthenticatedPfidaCalculatorsRoute
  '/_authenticated/_pfida/dip': typeof AuthenticatedPfidaDipRoute
  '/_authenticated/_pfida/documents': typeof AuthenticatedPfidaDocumentsRoute
  '/_authenticated/_pfida/finance-requirements': typeof AuthenticatedPfidaFinanceRequirementsRoute
  '/_authenticated/_pfida/grow-your-savings': typeof AuthenticatedPfidaGrowYourSavingsRoute
  '/_authenticated/_pfida/ifa-approval': typeof AuthenticatedPfidaIfaApprovalRoute
  '/_authenticated/_pfida/investor-hub': typeof AuthenticatedPfidaInvestorHubRoute
  '/_authenticated/_pfida/investor-type': typeof AuthenticatedPfidaInvestorTypeRoute
  '/_authenticated/_pfida/legal-notices': typeof AuthenticatedPfidaLegalNoticesRoute
  '/_authenticated/_pfida/referrals': typeof AuthenticatedPfidaReferralsRoute
  '/_authenticated/calculators/acceptance-principle': typeof AuthenticatedCalculatorsAcceptancePrincipleRoute
  '/_authenticated/calculators/affordability-calculator': typeof AuthenticatedCalculatorsAffordabilityCalculatorRoute
  '/_authenticated/calculators/calculation-history': typeof AuthenticatedCalculatorsCalculationHistoryRoute
  '/_authenticated/calculators/cost-calculator': typeof AuthenticatedCalculatorsCostCalculatorRoute
  '/_authenticated/property-purchase-plan_/$id': typeof AuthenticatedPropertyPurchasePlanIdRoute
  '/_unauthenticated/(auth-routes)/forgot-password': typeof UnauthenticatedauthRoutesForgotPasswordRoute
  '/_unauthenticated/(auth-routes)/login': typeof UnauthenticatedauthRoutesLoginRouteWithChildren
  '/_unauthenticated/(auth-routes)/signup': typeof UnauthenticatedauthRoutesSignupRoute
  '/_authenticated/_pfida/grow-your-savings_/$id': typeof AuthenticatedPfidaGrowYourSavingsIdRoute
  '/_authenticated/calculators/acceptance-principle_/result': typeof AuthenticatedCalculatorsAcceptancePrincipleResultRoute
  '/_unauthenticated/(auth-routes)/forgot-password_/confirm': typeof UnauthenticatedauthRoutesForgotPasswordConfirmRoute
  '/_unauthenticated/(auth-routes)/login/confim': typeof UnauthenticatedauthRoutesLoginConfimRoute
  '/_unauthenticated/(auth-routes)/login_/challenge-password': typeof UnauthenticatedauthRoutesLoginChallengePasswordRoute
  '/_unauthenticated/(auth-routes)/signup_/confirm': typeof UnauthenticatedauthRoutesSignupConfirmRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/property-purchase-plan'
    | '/additional-uploads-investor'
    | '/affordability-calculator'
    | '/cost-calculator'
    | '/investor-registration'
    | '/subscription-form'
    | '/about'
    | '/account-settings'
    | '/bank-details'
    | '/calculators'
    | '/dip'
    | '/documents'
    | '/finance-requirements'
    | '/grow-your-savings'
    | '/ifa-approval'
    | '/investor-hub'
    | '/investor-type'
    | '/legal-notices'
    | '/referrals'
    | '/calculators/acceptance-principle'
    | '/calculators/affordability-calculator'
    | '/calculators/calculation-history'
    | '/calculators/cost-calculator'
    | '/property-purchase-plan/$id'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/grow-your-savings/$id'
    | '/calculators/acceptance-principle/result'
    | '/forgot-password/confirm'
    | '/login/confim'
    | '/login/challenge-password'
    | '/signup/confirm'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/property-purchase-plan'
    | '/additional-uploads-investor'
    | '/affordability-calculator'
    | '/cost-calculator'
    | '/investor-registration'
    | '/subscription-form'
    | '/about'
    | '/account-settings'
    | '/bank-details'
    | '/calculators'
    | '/dip'
    | '/documents'
    | '/finance-requirements'
    | '/grow-your-savings'
    | '/ifa-approval'
    | '/investor-hub'
    | '/investor-type'
    | '/legal-notices'
    | '/referrals'
    | '/calculators/acceptance-principle'
    | '/calculators/affordability-calculator'
    | '/calculators/calculation-history'
    | '/calculators/cost-calculator'
    | '/property-purchase-plan/$id'
    | '/forgot-password'
    | '/login'
    | '/signup'
    | '/grow-your-savings/$id'
    | '/calculators/acceptance-principle/result'
    | '/forgot-password/confirm'
    | '/login/confim'
    | '/login/challenge-password'
    | '/signup/confirm'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/_authenticated/_pfida'
    | '/_authenticated/dashboard'
    | '/_authenticated/property-purchase-plan'
    | '/_unauthenticated/additional-uploads-investor'
    | '/_unauthenticated/affordability-calculator'
    | '/_unauthenticated/cost-calculator'
    | '/_unauthenticated/investor-registration'
    | '/_unauthenticated/subscription-form'
    | '/_authenticated/_pfida/about'
    | '/_authenticated/_pfida/account-settings'
    | '/_authenticated/_pfida/bank-details'
    | '/_authenticated/_pfida/calculators'
    | '/_authenticated/_pfida/dip'
    | '/_authenticated/_pfida/documents'
    | '/_authenticated/_pfida/finance-requirements'
    | '/_authenticated/_pfida/grow-your-savings'
    | '/_authenticated/_pfida/ifa-approval'
    | '/_authenticated/_pfida/investor-hub'
    | '/_authenticated/_pfida/investor-type'
    | '/_authenticated/_pfida/legal-notices'
    | '/_authenticated/_pfida/referrals'
    | '/_authenticated/calculators/acceptance-principle'
    | '/_authenticated/calculators/affordability-calculator'
    | '/_authenticated/calculators/calculation-history'
    | '/_authenticated/calculators/cost-calculator'
    | '/_authenticated/property-purchase-plan_/$id'
    | '/_unauthenticated/(auth-routes)/forgot-password'
    | '/_unauthenticated/(auth-routes)/login'
    | '/_unauthenticated/(auth-routes)/signup'
    | '/_authenticated/_pfida/grow-your-savings_/$id'
    | '/_authenticated/calculators/acceptance-principle_/result'
    | '/_unauthenticated/(auth-routes)/forgot-password_/confirm'
    | '/_unauthenticated/(auth-routes)/login/confim'
    | '/_unauthenticated/(auth-routes)/login_/challenge-password'
    | '/_unauthenticated/(auth-routes)/signup_/confirm'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated/subscription-form': {
      id: '/_unauthenticated/subscription-form'
      path: '/subscription-form'
      fullPath: '/subscription-form'
      preLoaderRoute: typeof UnauthenticatedSubscriptionFormRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/investor-registration': {
      id: '/_unauthenticated/investor-registration'
      path: '/investor-registration'
      fullPath: '/investor-registration'
      preLoaderRoute: typeof UnauthenticatedInvestorRegistrationRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/cost-calculator': {
      id: '/_unauthenticated/cost-calculator'
      path: '/cost-calculator'
      fullPath: '/cost-calculator'
      preLoaderRoute: typeof UnauthenticatedCostCalculatorRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/affordability-calculator': {
      id: '/_unauthenticated/affordability-calculator'
      path: '/affordability-calculator'
      fullPath: '/affordability-calculator'
      preLoaderRoute: typeof UnauthenticatedAffordabilityCalculatorRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/additional-uploads-investor': {
      id: '/_unauthenticated/additional-uploads-investor'
      path: '/additional-uploads-investor'
      fullPath: '/additional-uploads-investor'
      preLoaderRoute: typeof UnauthenticatedAdditionalUploadsInvestorRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/property-purchase-plan': {
      id: '/_authenticated/property-purchase-plan'
      path: '/property-purchase-plan'
      fullPath: '/property-purchase-plan'
      preLoaderRoute: typeof AuthenticatedPropertyPurchasePlanRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_pfida': {
      id: '/_authenticated/_pfida'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedPfidaRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_unauthenticated/(auth-routes)/signup': {
      id: '/_unauthenticated/(auth-routes)/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof UnauthenticatedauthRoutesSignupRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/(auth-routes)/login': {
      id: '/_unauthenticated/(auth-routes)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof UnauthenticatedauthRoutesLoginRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/(auth-routes)/forgot-password': {
      id: '/_unauthenticated/(auth-routes)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthenticatedauthRoutesForgotPasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/property-purchase-plan_/$id': {
      id: '/_authenticated/property-purchase-plan_/$id'
      path: '/property-purchase-plan/$id'
      fullPath: '/property-purchase-plan/$id'
      preLoaderRoute: typeof AuthenticatedPropertyPurchasePlanIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calculators/cost-calculator': {
      id: '/_authenticated/calculators/cost-calculator'
      path: '/calculators/cost-calculator'
      fullPath: '/calculators/cost-calculator'
      preLoaderRoute: typeof AuthenticatedCalculatorsCostCalculatorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calculators/calculation-history': {
      id: '/_authenticated/calculators/calculation-history'
      path: '/calculators/calculation-history'
      fullPath: '/calculators/calculation-history'
      preLoaderRoute: typeof AuthenticatedCalculatorsCalculationHistoryRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calculators/affordability-calculator': {
      id: '/_authenticated/calculators/affordability-calculator'
      path: '/calculators/affordability-calculator'
      fullPath: '/calculators/affordability-calculator'
      preLoaderRoute: typeof AuthenticatedCalculatorsAffordabilityCalculatorRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calculators/acceptance-principle': {
      id: '/_authenticated/calculators/acceptance-principle'
      path: '/calculators/acceptance-principle'
      fullPath: '/calculators/acceptance-principle'
      preLoaderRoute: typeof AuthenticatedCalculatorsAcceptancePrincipleRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_pfida/referrals': {
      id: '/_authenticated/_pfida/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthenticatedPfidaReferralsRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/legal-notices': {
      id: '/_authenticated/_pfida/legal-notices'
      path: '/legal-notices'
      fullPath: '/legal-notices'
      preLoaderRoute: typeof AuthenticatedPfidaLegalNoticesRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/investor-type': {
      id: '/_authenticated/_pfida/investor-type'
      path: '/investor-type'
      fullPath: '/investor-type'
      preLoaderRoute: typeof AuthenticatedPfidaInvestorTypeRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/investor-hub': {
      id: '/_authenticated/_pfida/investor-hub'
      path: '/investor-hub'
      fullPath: '/investor-hub'
      preLoaderRoute: typeof AuthenticatedPfidaInvestorHubRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/ifa-approval': {
      id: '/_authenticated/_pfida/ifa-approval'
      path: '/ifa-approval'
      fullPath: '/ifa-approval'
      preLoaderRoute: typeof AuthenticatedPfidaIfaApprovalRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/grow-your-savings': {
      id: '/_authenticated/_pfida/grow-your-savings'
      path: '/grow-your-savings'
      fullPath: '/grow-your-savings'
      preLoaderRoute: typeof AuthenticatedPfidaGrowYourSavingsRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/finance-requirements': {
      id: '/_authenticated/_pfida/finance-requirements'
      path: '/finance-requirements'
      fullPath: '/finance-requirements'
      preLoaderRoute: typeof AuthenticatedPfidaFinanceRequirementsRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/documents': {
      id: '/_authenticated/_pfida/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedPfidaDocumentsRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/dip': {
      id: '/_authenticated/_pfida/dip'
      path: '/dip'
      fullPath: '/dip'
      preLoaderRoute: typeof AuthenticatedPfidaDipRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/calculators': {
      id: '/_authenticated/_pfida/calculators'
      path: '/calculators'
      fullPath: '/calculators'
      preLoaderRoute: typeof AuthenticatedPfidaCalculatorsRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/bank-details': {
      id: '/_authenticated/_pfida/bank-details'
      path: '/bank-details'
      fullPath: '/bank-details'
      preLoaderRoute: typeof AuthenticatedPfidaBankDetailsRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/account-settings': {
      id: '/_authenticated/_pfida/account-settings'
      path: '/account-settings'
      fullPath: '/account-settings'
      preLoaderRoute: typeof AuthenticatedPfidaAccountSettingsRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_authenticated/_pfida/about': {
      id: '/_authenticated/_pfida/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AuthenticatedPfidaAboutRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
    '/_unauthenticated/(auth-routes)/signup_/confirm': {
      id: '/_unauthenticated/(auth-routes)/signup_/confirm'
      path: '/signup/confirm'
      fullPath: '/signup/confirm'
      preLoaderRoute: typeof UnauthenticatedauthRoutesSignupConfirmRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/(auth-routes)/login_/challenge-password': {
      id: '/_unauthenticated/(auth-routes)/login_/challenge-password'
      path: '/login/challenge-password'
      fullPath: '/login/challenge-password'
      preLoaderRoute: typeof UnauthenticatedauthRoutesLoginChallengePasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/(auth-routes)/login/confim': {
      id: '/_unauthenticated/(auth-routes)/login/confim'
      path: '/confim'
      fullPath: '/login/confim'
      preLoaderRoute: typeof UnauthenticatedauthRoutesLoginConfimRouteImport
      parentRoute: typeof UnauthenticatedauthRoutesLoginRoute
    }
    '/_unauthenticated/(auth-routes)/forgot-password_/confirm': {
      id: '/_unauthenticated/(auth-routes)/forgot-password_/confirm'
      path: '/forgot-password/confirm'
      fullPath: '/forgot-password/confirm'
      preLoaderRoute: typeof UnauthenticatedauthRoutesForgotPasswordConfirmRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/calculators/acceptance-principle_/result': {
      id: '/_authenticated/calculators/acceptance-principle_/result'
      path: '/calculators/acceptance-principle/result'
      fullPath: '/calculators/acceptance-principle/result'
      preLoaderRoute: typeof AuthenticatedCalculatorsAcceptancePrincipleResultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_pfida/grow-your-savings_/$id': {
      id: '/_authenticated/_pfida/grow-your-savings_/$id'
      path: '/grow-your-savings/$id'
      fullPath: '/grow-your-savings/$id'
      preLoaderRoute: typeof AuthenticatedPfidaGrowYourSavingsIdRouteImport
      parentRoute: typeof AuthenticatedPfidaRoute
    }
  }
}

interface AuthenticatedPfidaRouteChildren {
  AuthenticatedPfidaAboutRoute: typeof AuthenticatedPfidaAboutRoute
  AuthenticatedPfidaAccountSettingsRoute: typeof AuthenticatedPfidaAccountSettingsRoute
  AuthenticatedPfidaBankDetailsRoute: typeof AuthenticatedPfidaBankDetailsRoute
  AuthenticatedPfidaCalculatorsRoute: typeof AuthenticatedPfidaCalculatorsRoute
  AuthenticatedPfidaDipRoute: typeof AuthenticatedPfidaDipRoute
  AuthenticatedPfidaDocumentsRoute: typeof AuthenticatedPfidaDocumentsRoute
  AuthenticatedPfidaFinanceRequirementsRoute: typeof AuthenticatedPfidaFinanceRequirementsRoute
  AuthenticatedPfidaGrowYourSavingsRoute: typeof AuthenticatedPfidaGrowYourSavingsRoute
  AuthenticatedPfidaIfaApprovalRoute: typeof AuthenticatedPfidaIfaApprovalRoute
  AuthenticatedPfidaInvestorHubRoute: typeof AuthenticatedPfidaInvestorHubRoute
  AuthenticatedPfidaInvestorTypeRoute: typeof AuthenticatedPfidaInvestorTypeRoute
  AuthenticatedPfidaLegalNoticesRoute: typeof AuthenticatedPfidaLegalNoticesRoute
  AuthenticatedPfidaReferralsRoute: typeof AuthenticatedPfidaReferralsRoute
  AuthenticatedPfidaGrowYourSavingsIdRoute: typeof AuthenticatedPfidaGrowYourSavingsIdRoute
}

const AuthenticatedPfidaRouteChildren: AuthenticatedPfidaRouteChildren = {
  AuthenticatedPfidaAboutRoute: AuthenticatedPfidaAboutRoute,
  AuthenticatedPfidaAccountSettingsRoute:
    AuthenticatedPfidaAccountSettingsRoute,
  AuthenticatedPfidaBankDetailsRoute: AuthenticatedPfidaBankDetailsRoute,
  AuthenticatedPfidaCalculatorsRoute: AuthenticatedPfidaCalculatorsRoute,
  AuthenticatedPfidaDipRoute: AuthenticatedPfidaDipRoute,
  AuthenticatedPfidaDocumentsRoute: AuthenticatedPfidaDocumentsRoute,
  AuthenticatedPfidaFinanceRequirementsRoute:
    AuthenticatedPfidaFinanceRequirementsRoute,
  AuthenticatedPfidaGrowYourSavingsRoute:
    AuthenticatedPfidaGrowYourSavingsRoute,
  AuthenticatedPfidaIfaApprovalRoute: AuthenticatedPfidaIfaApprovalRoute,
  AuthenticatedPfidaInvestorHubRoute: AuthenticatedPfidaInvestorHubRoute,
  AuthenticatedPfidaInvestorTypeRoute: AuthenticatedPfidaInvestorTypeRoute,
  AuthenticatedPfidaLegalNoticesRoute: AuthenticatedPfidaLegalNoticesRoute,
  AuthenticatedPfidaReferralsRoute: AuthenticatedPfidaReferralsRoute,
  AuthenticatedPfidaGrowYourSavingsIdRoute:
    AuthenticatedPfidaGrowYourSavingsIdRoute,
}

const AuthenticatedPfidaRouteWithChildren =
  AuthenticatedPfidaRoute._addFileChildren(AuthenticatedPfidaRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedPfidaRoute: typeof AuthenticatedPfidaRouteWithChildren
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedPropertyPurchasePlanRoute: typeof AuthenticatedPropertyPurchasePlanRoute
  AuthenticatedCalculatorsAcceptancePrincipleRoute: typeof AuthenticatedCalculatorsAcceptancePrincipleRoute
  AuthenticatedCalculatorsAffordabilityCalculatorRoute: typeof AuthenticatedCalculatorsAffordabilityCalculatorRoute
  AuthenticatedCalculatorsCalculationHistoryRoute: typeof AuthenticatedCalculatorsCalculationHistoryRoute
  AuthenticatedCalculatorsCostCalculatorRoute: typeof AuthenticatedCalculatorsCostCalculatorRoute
  AuthenticatedPropertyPurchasePlanIdRoute: typeof AuthenticatedPropertyPurchasePlanIdRoute
  AuthenticatedCalculatorsAcceptancePrincipleResultRoute: typeof AuthenticatedCalculatorsAcceptancePrincipleResultRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedPfidaRoute: AuthenticatedPfidaRouteWithChildren,
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedPropertyPurchasePlanRoute:
    AuthenticatedPropertyPurchasePlanRoute,
  AuthenticatedCalculatorsAcceptancePrincipleRoute:
    AuthenticatedCalculatorsAcceptancePrincipleRoute,
  AuthenticatedCalculatorsAffordabilityCalculatorRoute:
    AuthenticatedCalculatorsAffordabilityCalculatorRoute,
  AuthenticatedCalculatorsCalculationHistoryRoute:
    AuthenticatedCalculatorsCalculationHistoryRoute,
  AuthenticatedCalculatorsCostCalculatorRoute:
    AuthenticatedCalculatorsCostCalculatorRoute,
  AuthenticatedPropertyPurchasePlanIdRoute:
    AuthenticatedPropertyPurchasePlanIdRoute,
  AuthenticatedCalculatorsAcceptancePrincipleResultRoute:
    AuthenticatedCalculatorsAcceptancePrincipleResultRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedauthRoutesLoginRouteChildren {
  UnauthenticatedauthRoutesLoginConfimRoute: typeof UnauthenticatedauthRoutesLoginConfimRoute
}

const UnauthenticatedauthRoutesLoginRouteChildren: UnauthenticatedauthRoutesLoginRouteChildren =
  {
    UnauthenticatedauthRoutesLoginConfimRoute:
      UnauthenticatedauthRoutesLoginConfimRoute,
  }

const UnauthenticatedauthRoutesLoginRouteWithChildren =
  UnauthenticatedauthRoutesLoginRoute._addFileChildren(
    UnauthenticatedauthRoutesLoginRouteChildren,
  )

interface UnauthenticatedRouteChildren {
  UnauthenticatedAdditionalUploadsInvestorRoute: typeof UnauthenticatedAdditionalUploadsInvestorRoute
  UnauthenticatedAffordabilityCalculatorRoute: typeof UnauthenticatedAffordabilityCalculatorRoute
  UnauthenticatedCostCalculatorRoute: typeof UnauthenticatedCostCalculatorRoute
  UnauthenticatedInvestorRegistrationRoute: typeof UnauthenticatedInvestorRegistrationRoute
  UnauthenticatedSubscriptionFormRoute: typeof UnauthenticatedSubscriptionFormRoute
  UnauthenticatedauthRoutesForgotPasswordRoute: typeof UnauthenticatedauthRoutesForgotPasswordRoute
  UnauthenticatedauthRoutesLoginRoute: typeof UnauthenticatedauthRoutesLoginRouteWithChildren
  UnauthenticatedauthRoutesSignupRoute: typeof UnauthenticatedauthRoutesSignupRoute
  UnauthenticatedauthRoutesForgotPasswordConfirmRoute: typeof UnauthenticatedauthRoutesForgotPasswordConfirmRoute
  UnauthenticatedauthRoutesLoginChallengePasswordRoute: typeof UnauthenticatedauthRoutesLoginChallengePasswordRoute
  UnauthenticatedauthRoutesSignupConfirmRoute: typeof UnauthenticatedauthRoutesSignupConfirmRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedAdditionalUploadsInvestorRoute:
    UnauthenticatedAdditionalUploadsInvestorRoute,
  UnauthenticatedAffordabilityCalculatorRoute:
    UnauthenticatedAffordabilityCalculatorRoute,
  UnauthenticatedCostCalculatorRoute: UnauthenticatedCostCalculatorRoute,
  UnauthenticatedInvestorRegistrationRoute:
    UnauthenticatedInvestorRegistrationRoute,
  UnauthenticatedSubscriptionFormRoute: UnauthenticatedSubscriptionFormRoute,
  UnauthenticatedauthRoutesForgotPasswordRoute:
    UnauthenticatedauthRoutesForgotPasswordRoute,
  UnauthenticatedauthRoutesLoginRoute:
    UnauthenticatedauthRoutesLoginRouteWithChildren,
  UnauthenticatedauthRoutesSignupRoute: UnauthenticatedauthRoutesSignupRoute,
  UnauthenticatedauthRoutesForgotPasswordConfirmRoute:
    UnauthenticatedauthRoutesForgotPasswordConfirmRoute,
  UnauthenticatedauthRoutesLoginChallengePasswordRoute:
    UnauthenticatedauthRoutesLoginChallengePasswordRoute,
  UnauthenticatedauthRoutesSignupConfirmRoute:
    UnauthenticatedauthRoutesSignupConfirmRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
